module.exports = __webpack_public_path__ + "fi-blue-flag-8f898be1d07363e582f182d99c17b53a.png";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/product-labels/fi-blue-flag.png
// module id = 81
// module chunks = 0